module.exports = __webpack_public_path__ + "static/media/ic_redo.3d17477e.svg";